export default "__VITE_ASSET__BRCuwPx9__"